/**
 * Shared text for field errors (wave 1, Oct 19 2026, STYLE_RULES.md rules 7
 * and 8). Pass the on-screen field label exactly. These builders change text
 * only; they do not change which fields are required.
 */

const cleanLabel = (label: string) =>
  label.trim().replace(/\s*\*$/, "").replace(/[.:]$/, "").trim();

const withArticle = (label: string) => {
  const clean = cleanLabel(label);
  // Possessive or already-specific labels keep their own wording.
  return /^(the|a|an|your|this|each|every|at least)\b/i.test(clean)
    ? clean
    : `the ${clean}`;
};

/** "Enter the [label]." for a typed field. */
export const enterFieldMessage = (label: string): string =>
  `Enter ${withArticle(label)}.`;

/** "Select the [label]." for a picker, list, or date field. */
export const selectFieldMessage = (label: string): string =>
  `Select ${withArticle(label)}.`;

export const EMAIL_FORMAT_MESSAGE =
  "Enter a full email address, for example name@example.com.";

export const WEB_ADDRESS_FORMAT_MESSAGE =
  "Enter a web address, for example www.example.com or https://www.example.com.";

export const PHONE_FORMAT_MESSAGE =
  "Enter a 10-digit phone number, for example 705-555-0123.";

export const DATE_FORMAT_MESSAGE =
  "Enter a full date, for example 2026-10-19.";

/** "[Later Date Label] must be on or after [Earlier Date Label]." */
export const dateOrderMessage = ({
  earlierLabel,
  laterLabel,
}: {
  earlierLabel: string;
  laterLabel: string;
}): string =>
  `${cleanLabel(laterLabel)} must be on or after ${cleanLabel(earlierLabel)}.`;

/** Summary for a form with several field errors (Edit Invoice text). */
export const FIX_MARKED_FIELDS_MESSAGE =
  "Fix the fields marked in red, then try again.";
